// import firebase from "firebase";
import { initializeApp } from "firebase/app";
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { register } from "../serviceWorker";

class FirebaseAuthBackend {
  // messaging;
  constructor(firebaseConfig) {
    // if (firebaseConfig) {
    //   // Initialize Firebase
    //   this.fc = firebaseConfig;
    //   this.app = initializeApp(firebaseConfig);
    //   this.messaging = getMessaging(this.app);
    //   // firebase.auth().onAuthStateChanged(user => {
    //   //   if (user) {
    //   //     localStorage.setItem("authUser", JSON.stringify(user));
    //   //   } else {
    //   //     localStorage.removeItem("authUser");
    //   //   }
    //   // });
    // }
  }

  // get Permission

  // Sendrequest = async () => {

  //   console.log("Requesting User Permission……");

  //   // Notification.requestPermission().then((permission) => {
  //   //   if (permission === "granted") {
  //   //     console.log("Notification User Permission Granted.");
  //   //     return firebase().messaging().getToken(messaging, { vapidKey: `CxPvh3uJVQxV5qKZ-xiZUrLF7iypF34rj9-rGhPVo7I` })
  //   //       .then((currentToken) => {
  //   //         if (currentToken) {
  //   //           console.log("Client Token: ", currentToken);
  //   //         } else {
  //   //           console.log("Failed to generate the registration token.");
  //   //         }
  //   //       })
  //   //       .catch((err) => {
  //   //         console.log("An error occurred when requesting to receive the token.", err);
  //   //       });

  //   //   } else {

  //   //     console.log("User Permission Denied.");

  //   //   }

  //   // });
  //   const permissionGranted = await Notification.requestPermission();
  //       if (permissionGranted === 'granted') {
  //         console.log('Notification permission granted');

  //         // Request FCM token after permission is granted
  //         console.log(this.messaging)
  //         register(this.fc)
  //         const currentToken = await getToken(this.messaging, {vapidKey: 'BM7Ri2mkD0XHN9_PrdW7oW6jegEuzFobg63sCf4pRMx—1MqlPbJk7v6xCfGYeubw6mOqkbpSPt_JK32dadF6DY'});
  //         console.log('FCM Token:', currentToken);

  //         // Listen for incoming messages
  //         const unsubscribe = onMessage(this.messaging, (payload) => {
  //           console.log('Message received:', payload);
  //           // Handle the received message as needed
  //         });

  //         // Unsubscribe from message listener when the component unmounts
  //         return () => unsubscribe();
  //       } else {
  //         console.warn('Notification permission denied');
  //       }


  //   // this.messaging.getToken()
  //   // .then(currentToken => {
  //   //     if (currentToken) {
  //   //       console.log('FCM Token:', currentToken);
  //   //     } else {
  //   //       console.log('No registration token available. Request permission to generate one.');
  //   //     }
  //   //   })

  // }

  /**
   * Registers the user with given details
   */
  // registerUser = (email, password) => {
  //   return new Promise((resolve, reject) => {
  //     firebase
  //       .auth()
  //       .createUserWithEmailAndPassword(email, password)
  //       .then(
  //         user => {
  //           resolve(firebase.auth().currentUser);
  //         },
  //         error => {
  //           reject(this._handleError(error));
  //         }
  //       );
  //   });
  // };

  /**
   * Login user with given details
   */
  // loginUser = (email, password) => {
  //   return new Promise((resolve, reject) => {
  //     firebase
  //       .auth()
  //       .signInWithEmailAndPassword(email, password)
  //       .then(
  //         user => {
  //           resolve(firebase.auth().currentUser);
  //         },
  //         error => {
  //           reject(this._handleError(error));
  //         }
  //       );
  //   });
  // };

  /**
   * forget Password user with given details
   */
  // forgetPassword = email => {
  //   return new Promise((resolve, reject) => {
  //     firebase
  //       .auth()
  //       .sendPasswordResetEmail(email, {
  //         url: window.location.protocol + "//" + window.location.host + "/login"
  //       })
  //       .then(() => {
  //         resolve(true);
  //       })
  //       .catch(error => {
  //         reject(this._handleError(error));
  //       });
  //   });
  // };

  /**
   * Logout the user
   */
  // logout = () => {
  //   return new Promise((resolve, reject) => {
  //     firebase
  //       .auth()
  //       .signOut()
  //       .then(() => {
  //         resolve(true);
  //       })
  //       .catch(error => {
  //         reject(this._handleError(error));
  //       });
  //   });
  // };

  setLoggeedInUser = user => {
    localStorage.setItem("authUser", JSON.stringify(user));
  };

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    if (!localStorage.getItem("authUser")) return null;
    return JSON.parse(localStorage.getItem("authUser"));
  };

  /**
   * Handle the error
   * @param {*} error
   */
  // _handleError(error) {
  //   // var errorCode = error.code;
  //   var errorMessage = error.message;
  //   return errorMessage;
  // }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config
 */
const initFirebaseBackend = config => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
  return _fireBaseBackend;
};

export { initFirebaseBackend, getFirebaseBackend };
